module.exports = __webpack_public_path__ + "img/history1.0d979180.jpg";